import _ from 'lodash';
const isTruthyValue = (value: string | undefined) =>
  value && ['1', 'true', 'True', 'TRUE', 'yes', true].includes(value) ? true : false;
export const config = {
  userPoolId: process.env.REACT_APP_USER_POOL_ID, // no longer used
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID, // no longer used
  dataUrl: `${process.env.REACT_APP_DATA_URL as string}${
    (isTruthyValue(process.env.REACT_APP_IS_VIRTUAL) as boolean) ? '/virtual' : ''
  }`,
  authRedirect: process.env.REACT_APP_APPLICATION_AUTH_REDIRECT,
  loginUrl: process.env.REACT_APP_LOGIN_URL,
  tradingApi: process.env.REACT_APP_TRADING_API_URL,
  dashboardUrl: process.env.REACT_APP_DASHBOARD_URL,
  gaUaTrackingCode: process.env.REACT_APP_GA_UA_TRACKING_CODE_APPLICATION || '',
  ga4TrackingCode: process.env.REACT_APP_GA_TRACKING_ID || '',
  ga4VTTrackingCode: process.env.REACT_APP_VT_GA_TRACKING_ID || '',
  isProduction: process.env.REACT_APP_ENVIRONMENT === 'production',
  isBeta: process.env.REACT_APP_ENVIRONMENT === 'beta',
  isDev: process.env.REACT_APP_ENVIRONMENT === 'dev',
  isLocal: process.env.REACT_APP_ENVIRONMENT === 'local',
  isVirtual: isTruthyValue(process.env.REACT_APP_IS_VIRTUAL) as boolean,
  publicDir: process.env.TB_PUBLIC_DIR as string,
  subdirectory: (process.env.REACT_APP_TB_SUBDIRECTORY as string)
    ? (process.env.REACT_APP_TB_SUBDIRECTORY as string)
    : '',
  tradingApiWebSocketUrl: process.env.REACT_APP_TRADING_API_WS_URL as string,
  tradingApiWebsocketsNew: process.env.REACT_APP_TRADING_API_WS_URL_NEW as string,
  accountApplicationWebSocketUrl: process.env.REACT_APP_ACCOUNT_APPLICATION_WS_URL as string,
  expiringTokensWebSocketUrl: process.env.REACT_APP_EXPIRING_TOKENS_WS_URL as string,
  /** HubSpot portal ID (public). Set in production deploy env when using create-user form POST before RestHub. */
  hubSpotPortalId: (process.env.REACT_APP_HUBSPOT_PORTAL_ID || '').trim(),
  /** HubSpot form GUID for create-user lead (public). Set in production deploy env when using that flow. */
  hubSpotCreateUserFormGuid: (process.env.REACT_APP_HUBSPOT_CREATE_USER_FORM_GUID || '').trim(),
};
type EnvConfigType = typeof config;
export default config;
